export const thai = {
    global: {
        next: "ถัดไป",
        name: "ชื่อ",
        email: "อีเมล์",
        emailEtc: "name@example.com"
    },
    setupWizard: {
        stepOne: {
            title: "ยินดีต้อนรับ",
            hi: "สวัสดี",
            header: "ยินดีตอนรับสู่ Happily!",
            contentOne: "You’re awesome for initiating positive experiences in your workplace. With Happily, you’re enabling better feedback, recognition, learning, community and so much more!",
            contentTwo: "To get started, we need to get your team set up, select rewards, and send out invites. Let’s begin!",
            primaryLocation: "Primary Location",
        },
        stepTwo: {
            title: "สร้างทีม",
            header: "สร้างทีมขอบคุณ",
            contentOne: "Happily works in teams and managers are at the center. Feedback, Insights, and Reports are sent to team managers on each workday to help them better understand their team in real-time. Help us set up your team.",
            teamName: "ชื่อทีม",
            teamNameEtc: "ACME Inc",
            managersNameEt: "Manager’s Name",
            memberName: "ชื่อสมาชิก",
        },
        stepThree: {
            title: "เลือกของรางวัล",
            contentOne: "Your team can use coins and gems collected from answering daily questions (and other interactions) to redeem rewards! Select your rewards below. You can add custom rewards later on as well.",
            SelectOneTitle: "Company Perks",
            SelectOneContentOne: "Let your team redeem Early Release (leaving work early), Half-day Fridays, and Days Off and more!",
            SelectTwoTitle: "Gift Cards",
            SelectTwoContentOne: "Let your team redeem Gift Cards from local vendors and online stores.",
            SelectTwoContentTwo: "Buy credits to enable gift cards, no extra charges applied.",
        },
        stepFour: {
            title: "ยื่นยันและเชิญ",
            contentOne: "We’re almost done! Set a time you’d like your teams to receive their daily pulse questions. We recommend selecting the time when your team is commuting to work.",
            quickSettings: "QUICK SETTINGS",
            dailyPulse: "Daily Pulse",
            whatHappensNext: "WHAT HAPPENS NEXT",
            contentOneWhatHappensNext: "Invitations will be sent out to your team and everyone will receive their first set of daily pulse questions on the next workday.",
            contentTwoWhatHappensNext: "Explore your admin console to add members, view insights, create custom questions & rewards, or edit your account settings.",
        },
    },
    weMonthlyInsights: {
        yourMonthlyInsights: "Your Monthly Insights",
        howTOUse: "วิธีใช้งานข้อมูลจากรายงานนี้",
        thisReportIs: "รายงานนี้สร้างขึ้นโดยอิงจากการใช้งานและกิจกรรมที่เกิดขึ้น จากสิ่งที่เราสร้างขึ้นในแอป Happily จุดประสงค์ของข้อมูลนี้คือ การช่วยให้คุณได้นำข้อมูลไปพัฒนาความเข้าใจเกี่ยวกับตนเองและทีมของคุณให้ดียิ่งขึ้น โดยผลลัพธ์ที่ดีที่สุดก็คือ การได้มีบทสนทนาที่สร้างความเชื่อใจ ส่งเสริมจุดแข็ง และช่วยให้เอาชนะเรื่องท้าทายที่มีได้",
        monthly: {
            yourMonthlyInsights: "ข้อมูลแบบ insights ของคุณในเดือน",
            createdfor: "สำหรับ ",
            hereIsYour: "นี่คือรายงานฉบับเฉพาะของคุณในเดือน",
            weRecommendThatboss: "เราแนะนำให้คุณแชร์ข้อมูลนี้กับทีมเพื่อเริ่มต้นการพูดคุยกันอย่างมีประสิทธิผลและเพื่อการพัฒนาอย่างต่อเนื่อง ขอให้โชคดี!",
            weRecommendThat: "เราแนะนำให้คุณทำตามแนวทางต่อไปนี้ เพื่อเริ่มต้นบทสนทนาที่มีประสิทธิผลกับหัวหน้าของคุณ และมุ่งไปสู่การพัฒนาอย่างต่อเนื่อง ขอให้โชคดี!",
            yourContributions: "Your contributions",
            dailyAttendance: "การเข้าใช้งานรายวัน",
            feedbackShared: "เขียนแชร์ฟีดแบ็ก",
            recognitionGiven: "ให้การชื่นชม/มองเห็นคุณค่า",
            peerFeedback: "Peer Feedback",
            managerReplyRate: "อัตราการตอบกลับของหัวหน้า",
            insightsOpened: "การเปิดดูข้อมูล insights",
            y_you: "คุณ",
            y_youTeam: "ทีมของคุณ",
            howHaveWe: "ในช่วงเดือนที่มาพวกเรารู้สึกเป็นอย่างไรกันบ้าง?",
            m_day: "M",
            t_day: "T",
            w_day: "W",
            th_day: "Th",
            f_day: "F",
            s_day: "S",
            su_day: "Su",
            overallYourTeam: "ภาพรวม ทีมของคุณมี ",
            overallYourHad: "ภาพรวม คุณมี ",
            good: "good,",
            justOkay: "just okay,",
            and: "and",
            criticalDays: "critical days.",
            remidner: "REMINDER",
            yourPrimaryRole: "บทบาทหลักในการเป็นหัวหน้าไม่ใช่การทำให้ทุกคนมีความสุขทุกวัน แต่มันคือการทำให้แน่ใจว่า ทีมของคุณสามารถกลับมายืนหยัดได้เร็วเมื่อเจออุปสรรค เข้าใจ + พัฒนาคนที่มีความสามารถในมือ และช่วยให้พวกเขาแก้ไขปัญหาได้เมื่อต้องเจอกับความท้าทาย",
            howAreWe: "เราเป็นยังไงกันบ้างในแต่ละมิติของชีวิตการทำงาน?",
            keyAreasOf: "จุดแข็งและเรื่องท้าทายที่เป็นคีย์สำคัญสำหรับคุณ เพื่อคุยเพิ่มเติมกับหัวหน้า",
            keyAreasOfฺBoss: "จุดแข็งและเรื่องท้าทายที่เป็นคีย์สำคัญที่ควรโฟกัสร่วมกับพนักงานที่ขึ้นตรงกับคุณ",
            focusOnGetting: "จดจ่อกับการรู้จักตัวเองให้ดียิ่งขึ้น เพราะชีวิตของคนเรามีขึ้นและลงอยู่เสมอ จงอย่าเขินอายที่จะขอความช่วยเหลือเมื่อคุณจำเป็น",
            andYouHave: "เพราะคุณมีพลังในการทำให้วันของใครบางคนนั้นดีกว่าเดิม",
            howconsist: "How consistent have you been?",
            consistencycontributions: "You’ve contributed at a ",
            consistency: "consistency.",
            month_1: "Jan",
            month_2: "Feb",
            month_3: "Mar",
            month_4: "Apr",
            month_5: "May",
            month_6: "Jun",
            month_7: "Jul",
            month_8: "Aug",
            month_9: "Sep",
            month_10: "Oct",
            month_11: "Nov",
            month_12: "Dec",
        },
        strengths: {
            whatAreOur: "อะไรคือจุดแข็งของเรา ในมุมของทีมและมุมของบริษัท?",
            keyAreasOf: "จุดแข็ง 💪 และเรื่องท้าทาย ⚠️ ซึ่งเป็นคีย์สำคัญที่นำมาโฟกัสสำหรับทีมของคุณ",
        },
        engaged: {
            howEngagedAre: "ตอนนี้คุณรู้สึกผูกพันกับองค์กรแค่ไหน?",
            progressBasedOn: "อิงจากพฤติกรรมในการให้และตอบฟีดแบ็ก การชื่นชม และการพัฒนาตนเอง",
            previousMonth: "เดือนที่ผ่านมา",
            _engaged: "Engaged",
            _super: "Super",
            _highly: "Highly",
            _moderately: "Engaged",
            _somewhat: "Somewhat",
            _not: "Under",
            youHave: "ในทีมของคุณมี",
            superEngaged: "Super Engaged",
            highlyEngaged: "Highly Engaged",
            moderatelyEngaged: "Engaged",
            somewhatEngaged: "Somewhat Engaged",
            notEngaged: "Not Engaged",
            inActive: "In-Active",
            underEngaged: "Under Engaged",
            youAre: "คุณอยู่ในกลุ่ม ",
            hereIsAn: " และนี่คือภาพรวมของด้าน engagement และ challenges ที่สำคัญของคุณ:",
            membersOnYour: "มาปลดล็อกด้านที่มีปัญหาเพื่อเพิ่มและส่งเสริมความผูกพัน",
            dailyCheckIns: "Daily Check-ins",
            peerFeedback: "Peer Feedback",
            _feedback: "Feedback",
            happilyVillage: "Happily Village",
            superFeedback: "Super Feedback",
            rewards: "Rewards",
            recognition: "Recognition",
            favoritedSparks: "Favorited Sparks",
            superRecognition: "Super Recognition",
            networkBuilding: "Network Building",
            youIndicatedThat: "You indicated that",
            isNoLonger: "is no longer on the team. How can we help?",
            cancel: "Cancel",
            notifyAdmins: "Notify Admins",
        },
        connections: {
            howAreWe: "เราสร้างเครือข่ายของเราได้อย่างไร?",
            basedOnRecognition: "อิงจากการชื่นชม ฟีดแบ็กแบบ 1:1 และการให้ของขวัญกันและกัน",
            youHaveA: "คุณมีทั้งหมด ",
            connections: "connections",
            innerNetwork: "Inner network",
            newConnectionsThis: "คอนเนคชั่นใหม่เดือนนี้",
            outerNetwork: "Outer network",
            buildingRelationshipsIs: "การสร้างความสัมพันธ์เป็นส่วนสำคัญของที่ทำงานของเรา เครือข่ายภายในทีมที่แข็งแกร่งส่งเสริมการทำงานร่วมกัน เครือข่ายนอกทีมที่แข็งแกร่งช่วยในการรวบรวมข้อมูล ไอเดียต่างๆ และวิธีแก้ไขปัญหาใหม่ๆ",
        },
        growing: {
            howAreWe: "เราจะเติบโตและพัฒนาได้อย่างไร?",
            progressBasedOn: "การเติบโตและพัฒนาของคุณ อิงจากหัวหน้า การชื่นชม และ peer feedback",
            youAreHere: "You are here",
            youWereHere: "You were here",
            progressBasedOnBoss: "การเติบโตและพัฒนาของคุณและทีมของคุณอ้างจาก หัวหน้า การชื่นชม และ peer feedback",
            individualPerformance: "Individual Performance (หัวหน้า)",
            networkEffectiveness: "Network Effectiveness (เพื่อนร่วมงาน)",
            s_starPerformer: "STAR PERFORMER",
            trulyOutstanding: "Truly Outstanding",
            yourDirectReports: "พนักงานที่ขึ้นตรงกับคุณ",
            showMore: "ดูเพิ่ม ",
            didNotParticipate: "ไม่ได้เข้าร่วมหรือรับ Peer Feedback ในเดือนนี้",
            Impact_Rating: "Impact Rating",
            Network_Type: "Network Type",
            Achievements: "Achievements",
            POOR: "ต่ำ",
            LOW:"ต่ำ",
            OKAY: "พอใช้",
            GREAT: "ดีมาก",
            EXCELLENT: "ยอดเยี่ยม",
            A_score_that_represents: "คะแนนที่แสดงให้เห็นถึงการมีอิมแพ็กของปัจเจกบุคคลต่อองค์กร และเพื่อนร่วมงานรอบตัว โดยกำหนดจาก",
            Based_on_manager_and: "อ้างอิงจากการชื่นชมจากหัวหน้าและเพื่อนร่วมงานในช่วง 6 เดือนที่ผ่านมา",
            Truly_Outstanding_ratings_from: "ผลคะแนนโดดเด่นน่าจับตามองผ่านการได้รับ Peer Feedback ในช่วง 6 เดือนที่ผ่านมา",
            Number_of_weeks_qualified: "จำนวนสัปดาห์ที่ได้เป็น Star Performer ในช่วง 6 เดือนที่ผ่านมา",
            Medals_received_in_the: "การได้รับเหรียญเกียรติยศในช่วง 6 เดือนที่ผ่านมา",
            Based_on_connections_created: "อ้างอิงจากสายสัมพันธ์ (connection) ที่สร้างขึ้นผ่านการให้ peer feedback การชื่นชม และการส่งของขวัญให้แก่กันในช่วง 6 เดือนที่ผ่านมา",
            Based_on_the_quality_and: "ยอดเยี่ยม อ้างอิงจากคุณภาพและความพยายามในพฤติกรรมการมีส่วนร่วมที่เกิดขึ้นในเดือนที่ผ่านมา",
        }
    },
    weQuarterlyInsights: {
        yourQuarterlyInsights: "รายงานรายไตรมาสของคุณ",
        howTOUse: "วิธีใช้รายงานนี้",
        thisReportIs: "รายงานนี้สร้างขึ้นจากการโต้ตอบที่เราอำนวยความสะดวกใน Happily app วัตถุประสงค์ของข้อมูลนี้คือเพื่อช่วยให้คุณพัฒนาความเข้าใจที่ดีขึ้นเกี่ยวกับตัวเองและทีมของคุณ ผลลัพธ์ที่ดีที่สุดคือการสนทนาที่สร้างความไว้วางใจ เสริมจุดแข็ง และช่วยเอาชนะความท้าทาย",
        quarterly: {
            yourQuarterlyInsights: "รายงานรายไตรมาสของคุณสำหรับ",
            createdfor: "สร้างขึ้นสำหรับ",
            hereIsYour: "นี่คือรายงานการมีส่วนร่วมของคุณสำหรับ",
            weRecommendThatboss: " เราขอแนะนำให้คุณแบ่งปันข้อมูลเชิงลึกกับทีมของคุณที่จะริเริ่มการสนทนาที่มีประสิทธิภาพและการปรับปรุงอย่างต่อเนื่อง โชคดี!",
            weRecommendThat: " เราขอแนะนำให้คุณใช้สิ่งนี้เป็นแนวทางในการริเริ่มการสนทนาที่มีประสิทธิผลกับผู้จัดการของคุณเพื่อการปรับปรุงอย่างต่อเนื่อง โชคดี!",
            yourContributions: "การมีส่วนร่วมของคุณ",
            dailyAttendance: "การเข้าร่วมประจำวัน",
            feedbackShared: "ข้อเสนอแนะที่แบ่งปัน",
            recognitionGiven: "การยกย่องที่ให้ไป",
            peerFeedback: "ข้อเสนอแนะจากเพื่อนร่วมงาน",
            managerReplyRate: "อัตราการตอบกลับของผู้จัดการ",
            insightsOpened: "เปิดดู Insights",
            y_you: "คุณ",
            y_youTeam: "ทีมของคุณ",
            howHaveWe: "เรารู้สึกอย่างไรในไตรมาสที่ผ่านมา?",
            m_day: "จ",
            t_day: "อ",
            w_day: "พ",
            th_day: "พฤ",
            f_day: "ศ",
            s_day: "ส",
            su_day: "อา",
            yourTeam: "ทีมของคุณ",
            overallYourTeam: "โดยรวมแล้ว ทีมของคุณมี",
            overallYourHad: "โดยรวมแล้ว คุณมี",
            good: "ดี,",
            justOkay: "พอใช้,",
            and: "และ",
            criticalDays: "วันที่วิกฤต",
            remidner: "เตือนความจำ",
            yourPrimaryRole: "บทบาทหลักของคุณในฐานะผู้จัดการคนไม่ใช่การทำให้ทุกคนมีความสุขทุกวัน แต่เป็นการทำให้ทีมของคุณฟื้นตัวได้อย่างรวดเร็วจากความพ่ายแพ้และเข้าใจและพัฒนาความสามารถของคุณและช่วยแก้ไขปัญหาของทีม",
            howAreWe: "เราทำงานได้ดีแค่ไหนในด้านต่างๆ?",
            keyAreasOf: "ประเด็นสำคัญของจุดแข็งและความท้าทายสำหรับคุณเพื่อไตร่ตรองกับผู้จัดการของคุณ",
            keyAreasOfฺBoss: "ประเด็นสำคัญของจุดแข็งและความท้าทายที่จะนำไปโฟกัสกับผู้ใต้บังคับบัญชาของคุณ",
            focusOnGetting: "มุ่งเน้นไปที่การรู้จักตัวเองให้ดีขึ้น จะมีขึ้นและลงเสมอ อย่ากลัวที่จะขอความช่วยเหลือเมื่อจำเป็น",
            andYouHave: "และคุณมีพลังที่จะทำให้วันของใครบางคนดีขึ้น ",
            howconsist: "คุณสม่ำเสมอแค่ไหน?",
            consistencycontributions: "คุณได้มีส่วนร่วมที่ ",
            consistency: "สม่ำเสมอ",
            month_1: "ม.ค.",
            month_2: "ก.พ.",
            month_3: "มี.ค.",
            month_4: "เม.ย.",
            month_5: "พ.ค.",
            month_6: "มิ.ย.",
            month_7: "ก.ค.",
            month_8: "ส.ค.",
            month_9: "ก.ย.",
            month_10: "ต.ค.",
            month_11: "พ.ย.",
            month_12: "ธ.ค.",
        },
        strengths: {
            whatAreOur: "จุดแข็งหลักและจุดที่ต้องโฟกัสในไตรมาสนี้",
            keyAreasOf: "ด้านที่แสดงจุดแข็งอย่างสม่ำเสมอและด้านที่ต้องการความสนใจตลอดไตรมาส",
        },
        engaged: {
            howEngagedAre: "เรามีส่วนร่วมมากแค่ไหนในขณะนี้?",
            progressBasedOn: "อ้างอิงจากพฤติกรรมเกี่ยวกับการให้ข้อเสนอแนะ การยกย่อง และการพัฒนาตนเอง",
            previousMonth: "ไตรมาสก่อนหน้า",
            _engaged: "มีส่วนร่วม",
            _super: "สุดยอด",
            _highly: "สูง",
            _moderately: "มีส่วนร่วม",
            _somewhat: "พอสมควร",
            _not: "ต่ำ",
            inActive: "ไม่ใช้งาน",
            youHave: "คุณมี",
            superEngaged: "มีส่วนร่วมสุดยอด",
            highlyEngaged: "มีส่วนร่วมสูง",
            moderatelyEngaged: "มีส่วนร่วม",
            somewhatEngaged: "มีส่วนร่วมพอสมควร",
            notEngaged: "ไม่มีส่วนร่วม",
            underEngaged: "มีส่วนร่วมต่ำ",
            youAre: "คุณเป็น",
            hereIsAn: " นี่คือภาพรวมของพื้นที่การมีส่วนร่วมและความท้าทายที่สำคัญของคุณ:",
            membersOnYour: "สมาชิกในทีมของคุณ ปลดล็อคพื้นที่สำคัญเพื่อเพิ่มการมีส่วนร่วม",
            dailyCheckIns: "การเช็คอินประจำวัน",
            peerFeedback: "ข้อเสนอแนะจากเพื่อนร่วมงาน",
            _feedback: "ข้อเสนอแนะ",
            happilyVillage: "Happily Village",
            superFeedback: "ข้อเสนอแนะสุดยอด",
            rewards: "รางวัล",
            recognition: "การยกย่อง",
            favoritedSparks: "Sparks ที่ชื่นชอบ",
            superRecognition: "การยกย่องสุดยอด",
            networkBuilding: "การสร้างเครือข่าย",
            youIndicatedThat: "คุณระบุว่า",
            isNoLonger: "ไม่ได้อยู่ในทีมอีกต่อไป เราจะช่วยได้อย่างไร?",
            cancel: "ยกเลิก",
            notifyAdmins: "แจ้งผู้ดูแลระบบ",
        },
        connections: {
            howAreWe: "เรากำลังสร้างการเชื่อมต่ออย่างไร?",
            basedOnRecognition: "อ้างอิงจากการยกย่อง ข้อเสนอแนะจากเพื่อนร่วมงาน และการโต้ตอบการให้ของขวัญ",
            youHaveA: "คุณมีทั้งหมด",
            connections: "การเชื่อมต่อ",
            innerNetwork: "เครือข่ายภายใน",
            newConnectionsThis: "การเชื่อมต่อใหม่ในไตรมาสนี้",
            outerNetwork: "เครือข่ายภายนอก",
            buildingRelationshipsIs: "การสร้างความสัมพันธ์เป็นส่วนสำคัญของสถานที่ทำงานของเรา เครือข่ายภายในที่แข็งแกร่งส่งเสริมการทำงานร่วมกัน เครือข่ายภายนอกที่แข็งแกร่งช่วยให้เรารวบรวมข้อมูล ไอเดีย และแก้ปัญหาใหม่ๆ",
        },
        growing: {
            howAreWe: "เรากำลังเติบโตและพัฒนาอย่างไร?",
            progressBasedOn: "ความคืบหน้าของคุณอ้างอิงจากการยกย่องจากผู้จัดการและเพื่อนร่วมงาน และข้อเสนอแนะจากเพื่อนร่วมงาน",
            youAreHere: "คุณอยู่ที่นี่",
            youWereHere: "คุณเคยอยู่ที่นี่",
            progressBasedOnBoss: "ความคืบหน้าของคุณและทีมของคุณอ้างอิงจากการยกย่องจากผู้จัดการและเพื่อนร่วมงาน และข้อเสนอแนะจากเพื่อนร่วมงาน",
            individualPerformance: "ประสิทธิภาพส่วนบุคคล (ผู้จัดการ)",
            networkEffectiveness: "ประสิทธิผลของเครือข่าย (เพื่อนร่วมงาน)",
            s_starPerformer: "ผู้ปฏิบัติงานดีเด่น",
            trulyOutstanding: "ยอดเยี่ยมอย่างแท้จริง",
            yourDirectReports: "ผู้ใต้บังคับบัญชาของคุณ",
            showMore: "โหลดเพิ่มเติม ",
            didNotParticipate: "ไม่ได้เข้าร่วมหรือได้รับข้อเสนอแนะจากเพื่อนร่วมงานในไตรมาสนี้",
            Impact_Rating: "คะแนนผลกระทบ",
            Network_Type: "ประเภทเครือข่าย",
            Achievements: "ความสำเร็จ",
            POOR: "แย่",
            LOW:"ต่ำ",
            OKAY: "โอเค",
            GREAT: "ยอดเยี่ยม",
            EXCELLENT: "ดีเยี่ยม",
            A_score_that_represents: "คะแนนที่แสดงถึงผลกระทบของบุคคลต่อองค์กรและผู้คนรอบข้าง กำหนดโดย:",
            Based_on_manager_and: "อ้างอิงจากการยกย่องจากผู้จัดการและเพื่อนร่วมงานในช่วง 6 เดือนที่ผ่านมา",
            Truly_Outstanding_ratings_from: "การให้คะแนนยอดเยี่ยมอย่างแท้จริงจากข้อเสนอแนะจากเพื่อนร่วมงานที่ได้รับในช่วง 6 เดือนที่ผ่านมา",
            Number_of_weeks_qualified: "จำนวนสัปดาห์ที่มีคุณสมบัติเป็นผู้ปฏิบัติงานดีเด่นในช่วง 6 เดือนที่ผ่านมา",
            Medals_received_in_the: "เหรียญที่ได้รับในช่วง 6 เดือนที่ผ่านมา",
            Based_on_connections_created: "อ้างอิงจากการเชื่อมต่อที่สร้างขึ้นผ่านข้อเสนอแนะจากเพื่อนร่วมงาน การยกย่อง และการโต้ตอบการให้ของขวัญในช่วง 6 เดือนที่ผ่านมา",
            Based_on_the_quality_and: "ยอดเยี่ยม อ้างอิงจากคุณภาพและความพยายามในพฤติกรรมการมีส่วนร่วมที่เกิดขึ้นในไตรมาสที่ผ่านมา",
        }
    },
    questionDetail: {
        QUESTION_DETAILS: "QUESTION DETAILS",
        Scale: "Scale",
        Multiple_Choice: "Multiple Choice",
        Yes_No: "Yes/No",
        average: "ค่าเฉลี่ย",
        out_of_10: "จาก 10",
        responses: "คำตอบ",
        response: "คำตอบ",
        score: "คะแนน",
    }
};